import React, { useEffect, useState} from 'react';
import moment from 'moment';
import { connect } from 'react-redux';

import { bool, func, object, shape, string } from 'prop-types';
import classes from './PreviewSensorDataModal.module.css';

import EsmsDialog from '../../components/EsmsDialog';

import ActionBar from '../../components/ActionBar';
import SensorDataTimestampFilter from './SensorDataTimestampFilter';
import * as sensorDataActions from '../../actions/sensorDataActions';

import SensorDataTable from '../Architect/SensorDataTable';

const PreviewSensorDataModal = ({
    clearSensorData,
    close,
    errors,
    fetchSensorData,
    pollingInterval,
    sensorData,
    selectedSensor,
    history,
    location,
    open,
    title
}) => {

    function fetchOnRender() {
        const params = new URLSearchParams(location.search);
        const endDate = moment(params.get('endTimestamp') || undefined).local();
        const startDate = moment(params.get('startTimestamp') || undefined).local();

        if (!params.has('startTimestamp')) {
            startDate.subtract('4', 'hours');
        }

        if (selectedSensor.id && open) {
            fetchSensorData(
                {
                    sensorId:       selectedSensor.id,
                    startTimestamp: startDate.toISOString(),
                    endTimestamp:   endDate.toISOString()
                },
                pollingInterval
            );
        }
    }

    function parseEndTimestamp(searchParams) {
        const params = new URLSearchParams(searchParams);
        const endDate = moment(params.get('endTimestamp') || undefined).local();
        return endDate;
    }
    
    function parseStartTimestamp(searchParams) {
        const params = new URLSearchParams(searchParams);
        const startDate = moment(params.get('startTimestamp') || undefined).local();
        if (!params.has('startTimestamp')) {
            startDate.subtract('4', 'hours');
        }
        return startDate;
    }

    function handleFilterChange(filterName, value) {
        const newParams = new URLSearchParams(location.search);
        if (value) {
            newParams.set('startTimestamp', value.toISOString());
            const newValue = value.add('4', 'hours');
            newParams.set('endTimestamp', newValue.toISOString());

        } else {
            newParams.delete(filterName);
        }
        newParams.delete('page');
        history.replace({
            pathname: location.pathname,
            search:   newParams.toString()
        });
    }

    function handleClose() {
        const newParams = new URLSearchParams(location.search);
        newParams.delete('startTimestamp');
        newParams.delete('endTimestamp');
        history.replace({
            pathname: location.pathname,
            search:   newParams.toString()
        });
        close();
    }

    const [startTimestamp, setStartTimestamp] =
        useState(parseStartTimestamp(location.search));
    const [endTimestamp, setEndTimestamp] =
        useState(parseEndTimestamp(location.search));

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const endTimestamp = parseEndTimestamp(params);
        const startTimestamp = parseStartTimestamp(params);
        setStartTimestamp(startTimestamp);
        setEndTimestamp(endTimestamp);

        if (selectedSensor.id && open) {
            clearSensorData();
            fetchSensorData(
                {
                    sensorId:       selectedSensor.id,
                    endTimestamp:   endTimestamp.toISOString(),
                    startTimestamp: startTimestamp.toISOString()
                },
                pollingInterval
            );
        }
        return () => {};
    }, [location.search]);

    return (
        <EsmsDialog
            errors={errors}
            open={open}
            onClose={handleClose}
            onConfirm={close}
            onRendered={fetchOnRender}
            title={selectedSensor.sensorType ? `Preview ${selectedSensor.name} Data` : 'Preview Data'}
            isLoading={sensorData.loading}
            confirmText="Close"
        >
            
            <div className={classes.contentContainer}>
                <ActionBar
                    startAdornments={(
                        <SensorDataTimestampFilter
                            endTimestamp={endTimestamp}
                            onFilterChange={handleFilterChange}
                            startTimestamp={startTimestamp}
                        />
                    )}
                />
                <SensorDataTable sensorData={sensorData.items} isLoading={sensorData.loading} />
            </div>
        </EsmsDialog>
    );
};

PreviewSensorDataModal.defaultProps = {
    clearSensorData: () => {},
    idType:          '',
    sensorData:      () => {},
    fetchSensorData: () => {},
    isLoading:       false,
    location:        {},
    title:           ''
};

PreviewSensorDataModal.propTypes = {
    clearSensorData: () => {},
    error:           string,
    fetchSensorData: func,
    idType:          string,
    sensorData:      object,
    isLoading:       bool,
    location:        shape({
        search: string
    })
};

export const mapStateToProps = ({
    sensorData
}) => ({
    sensorData
});

const mapDispatchToProps = {
    ...sensorDataActions
};

export default connect(mapStateToProps, mapDispatchToProps)(PreviewSensorDataModal);
